import React from "react";
import { Container, LogoContainer, Logo, MenuDivider } from "./styles";
import Nav from "components/nav";
import UserInformation from "./userInformation";
import { navigate } from "@reach/router";
import routes from "utils/absoluteRoutes";

const SideMenu = ({ mobile, navOpen }) => {
  return (
    <Container mobile={mobile} navOpen={navOpen}>
      <LogoContainer>
        <Logo
          src={require(`assets/images/zlto_logo_white.svg`)}
          alt="Yoma logo"
          onClick={() => navigate(routes.bizProfile)}
        />
      </LogoContainer>
      <MenuDivider style={{ width: "100%" }} />
      {!mobile && <UserInformation />}
      <MenuDivider />
      <Nav />
    </Container>
  );
};
export default SideMenu;
